import controller from './templates.controller';
import templateT15 from './templates/templates-t15.view.html';
import templateBase from './templates/templates-base.view.html';

let TemplatesComponent = {
  template:changeTemplate,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
  let response = SessionService.get('components');

  if(__env.adaptative) {
    return templateBase;
  } else {
    if (response.TEMPLATE.component == 'template_t15') { return templateT15; }
    else {
      return templateBase;
    }
  }
}

export default TemplatesComponent;


// WEBPACK FOOTER //
// ./www/components/templates/templates.component.js